<template>
    <v-toolbar v-if="isVisible" class="marker-toolbar" elevation="2">
        <div class="tool-group">
            <v-btn icon class="tool-btn" :disabled="isSaving" @click="onRotate" title="Rotate (R)">
                <v-icon>mdi-rotate-right</v-icon>
            </v-btn>

            <v-btn icon class="tool-btn" :disabled="isSaving" @click="onScale" title="Scale (S)">
                <v-icon>mdi-magnify-scan</v-icon>
            </v-btn>

            <v-btn icon class="tool-btn" :disabled="isSaving" @click="onMove" title="Move (M)">
                <v-icon>mdi-cursor-move</v-icon>
            </v-btn>
        </div>

        <v-divider vertical class="toolbar-divider" />

        <div class="action-group">
            <v-btn class="save-btn" :loading="isSaving" :disabled="isSaving" @click="onSave">
                Save
            </v-btn>

            <v-btn class="cancel-btn" :disabled="isSaving" @click="onCancel">
                Cancel
            </v-btn>
        </div>
    </v-toolbar>
</template>

<script>
export default {
    name: "EditMarkerToolBar",
    emits: ['onRotate', 'onScale', 'onMove', 'onSave', 'onCancel'],
    props: {
        isVisible: {
            type: Boolean,
            required: true,
            default: false,
        },
        // Owned by the parent: it performs the async save, so it controls the spinner
        // and is responsible for clearing it on both success and failure.
        isSaving: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onRotate() {
            this.$emit('onRotate');
        },
        onScale() {
            this.$emit('onScale');
        },
        onMove() {
            this.$emit('onMove');
        },
        onSave() {
            this.$emit('onSave');
        },
        onCancel() {
            this.$emit('onCancel');
        }
    }
}
</script>

<style scoped>
.marker-toolbar {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    min-width: 320px;
    width: auto;
    background: linear-gradient(180deg, rgba(29, 43, 51, 0.96), rgba(26, 38, 45, 0.96));
    padding: 8px 12px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5), 0 0 18px rgba(100, 255, 218, 0.12);
    border: 1px solid rgba(100, 255, 218, 0.18);
    z-index: 10;
    color: #fff;
    backdrop-filter: blur(8px);
}

.tool-group {
    display: flex;
    align-items: center;
    gap: 4px;
}

.action-group {
    display: flex;
    align-items: center;
    gap: 6px;
}

.tool-btn {
    color: var(--duallo-accent-muted) !important;
    border-radius: 8px !important;
    transition: background-color 0.2s ease, transform 0.15s ease;
}

.tool-btn:hover {
    background-color: rgba(102, 199, 180, 0.14);
    transform: translateY(-1px);
}

.toolbar-divider {
    height: 28px;
    margin: 0 2px;
    opacity: 0.15;
}

.save-btn {
    background: var(--duallo-accent-gradient) !important;
    color: #071514 !important;
    font-weight: 700 !important;
    letter-spacing: 0.02em;
    text-transform: none !important;
    border-radius: 10px !important;
    min-width: 80px;
}

.cancel-btn {
    background: rgba(255, 255, 255, 0.04) !important;
    color: #cfd8dc !important;
    font-weight: 600 !important;
    text-transform: none !important;
    border-radius: 10px !important;
    min-width: 80px;
}

.cancel-btn:hover {
    background: rgba(239, 68, 68, 0.1) !important;
    color: #f87171 !important;
}
</style>